import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    background-color: #43474d;
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        padding: 0 20px;
    }
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    height: auto;
    
`
export const Text = styled.p`
    color: #8c8e91;
    font-size: 11px;
    padding: 25px 0 20px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        text-align: center;
    }
`

export const EmailLink = styled.a`
    color: #8c8e91;
    text-decoration: none;
    cursor: pointer;
    &:hover {
        color: #00a0e7;
        text-decoration: underline;
    }
`
